import * as types from "../types";

const userDetail = {
  firstName: "",
  middleName: "",
  lastName: "",
  mobileNo: "",
  consentFlag: "N",
  resiCity: "",
  dob: "",
  panNumber: "",
  motherName: "",
  emailId: "",
  occupation: "",
  companyName: "",
  companyCategory: "",
  companyAlias: "",
  designation: "",
  officeAddr: {
    addrLine1: "",
    addrLine2: "",
    addrLine3: "",
    pinCode: "",
    city: "",
    state: "",
  },
  gender: "",
  resiAddr: {
    houseNo: "",
    locality: "",
    resiAddressLine2: "",
    landmark: "",
    pin: "",
    state: "",
    city: "",
    addressType: "",
  },
  channelCode: "SAPL",
  sourceCode: "WEBS",
  cardType: "",
  shortCode: "",
  submitAction: "",
  //multicardUrl: "",
  //panGender: "",
  isCookieData: false,
  referralCode: "",
  ffnNo: "",
  gemid1: "",
  gemid2: "",
  accountDetails: {},
  eCard: {},
  leadSource:"",
  hsToken: "",
  oauth: {
    accessToken: "",
    cookie: "",
    clientIPAddress: "",
    passPharse: "",
  },
  photoMatchStatus: false,
  pennyCreditStatus: false,
  pennyDebitStatus: false,
  leadRefNo:"",
  currentNwType:"",
  priority:0,
  isNwChanged:"N",
  productType:"",
  selCurrCardType:"",
  selectedSurrogate:null,
  coreCardChannel:""
};

const initState = {
  UserDetail: userDetail,
  valError: null,
};

const UserReducer = (state = initState, action) => {
  switch (action.type) {
    case types.SAVE_PERSONAL_DETAILS:
      return {
        ...state,
        UserDetail: action.payload,
        valError: action.error,
      };
    case types.SAVE_VAL_ERROR:
      return {
        ...state,
        valError: action.payload,
      };
    case types.CLEAR_USER_DATA:
      return {
        ...state,
        UserDetail: userDetail,
      };
	case types.SAVE_SELECTED_NW_DATA:
      return {
        ...state,
        UserDetail: action.payload,
          
        } ;
        case types.SAVE_SELECTED_SURROGATE:
          return {
            ...state,
        UserDetail: {
          ...state.UserDetail,
          selectedSurrogate:action.payload,
        }
          }
    default:
      return state;
  }
};

export default UserReducer;
